export default {
    computed: {
        client() {
            return this.$store.getters['homevantage/getClient'];
        },
        quote_id() {
            return this.$store.getters['calculators/getQuoteId'];
        },
        client_target_interest_rate() {
            return this.$store.getters['homevantage/getClientTargetInterestRate'];
        },
        client_target_interest_rate_label() {
            return this.$store.getters['homevantage/getClientTargetInterestRateLabel'];
        },
        benefits() {
            return this.$store.getters['homevantage/getBenefits'];
        },
        benefits_requested() {
            return this.$store.getters['homevantage/getBenefitsRequested'];
        },
        age_range() {
            return this.$store.getters['homevantage/getAgeRange'];
        },

        qualified_bond() {
            return this.$store.getters['homevantage/getQualifiedBond'];
        },
        qualified_bond_requested() {
            return this.$store.getters['homevantage/getQualifiedBondRequested'];
        },

        banks() {
            return this.$store.getters['homevantage/getBanks'];
        },
        transactions() {
            return this.$store.getters['homevantage/getTransactions'];
        },
        transfer_duties() {
            return this.$store.getters['homevantage/getTransferDuties'];
        },
        attorney_fees_options() {
            return this.$store.getters['homevantage/getAttorneyFeesOptions'];
        },
        home_cover_options() {
            return this.$store.getters['homevantage/getHomeCoverOptions'];
        },
        life_cover_types() {
            return this.$store.getters['homevantage/getLifeCoverTypes'];
        },
        life_cover_options() {
            return this.$store.getters['homevantage/getLifeCoverOptions'];
        },
        attorney_options() {
            return this.$store.getters['homevantage/getAttorneyOptions'];
        },
        prime_targets() {
            return this.$store.getters['homevantage/getPrimeTargets'];
        },
        advantage_options() {
            return this.$store.getters['homevantage/getAdvantageOptions'];
        },
        will_options() {
            return this.$store.getters['homevantage/getWillOptions'];
        },

        loan_terms() {
            return this.$store.getters['homevantage/getTerms'];
        },

        intermediaryId() {
            let url = new window.domurl;

            if (typeof url.query.intermediary !== 'undefined') {
                return url.query.intermediary;
            }

            return null;
        },

        bondPercentage: {
            set(value) {
                this.$store.commit('homevantage/setBondPercentage', value);
            },
            get() {
                return this.$store.getters['homevantage/getBondPercentage'];
            }
        },
    },

    methods: {}
};
